// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchAllFallAlerts,
//   acknowledgeFallAlertById,
// } from "../../redux/slices/AlertTableSlice";

// import { Modal, Button, Form, Badge } from "react-bootstrap";
// import "./AdminCSS/Details.css";

// const FallAlerts = () => {
//   const dispatch = useDispatch();
//   const { alerts = [], loading, error } = useSelector(
//     (state) => state.fallAlerts
//   );

//   const [showAckModal, setShowAckModal] = useState(false);
//   const [showVideoModal, setShowVideoModal] = useState(false);
//   const [selectedAlert, setSelectedAlert] = useState(null);
//   const [note, setNote] = useState("");

//   // ================= FETCH FALL ALERTS =================
//   useEffect(() => {
//     dispatch(fetchAllFallAlerts());
//   }, [dispatch]);

//   // ================= ACKNOWLEDGE =================
//   const openAcknowledgeModal = (alert) => {
//     setSelectedAlert(alert);
//     setNote(alert.note || "");
//     setShowAckModal(true);
//   };

//   const confirmAcknowledge = () => {
//     if (!selectedAlert) return;

//     dispatch(
//       acknowledgeFallAlertById({
//         alertId: selectedAlert.alert_id,
//         alert_acknowledged: true,
//         note: note,
//         user_id: selectedAlert.user_id,
//       })
//     );

//     setShowAckModal(false);
//   };

//   // ================= VIDEO =================
//   const openVideoModal = (alert) => {
//     setSelectedAlert(alert);
//     setShowVideoModal(true);
//   };

//   const buildEvidenceUrl = (path) => {
//     if (!path) return null;
//     if (path.startsWith("http")) return path;
//     return `${process.env.REACT_APP_API_URL}/static/${path}`;
//   };

//   return (
//     <div className="Devices-page">
//       <h2 style={{ marginBottom: "20px" }}>Fall Alerts</h2>

//       {loading && <p>Loading fall alerts...</p>}
//       {error && <p style={{ color: "red" }}>{error}</p>}

//       {!loading && !error && (
//         <div className="table-scroll-container">
//           <table className="device-table">
//             <thead>
//               <tr>
//                 <th>Time</th>
//                 <th>Patient ID</th>
//                 <th>Event</th>
//                 <th>Reason</th>
//                 <th>Status</th>
//                 <th>Note</th>
//                 <th>Operations</th>
//               </tr>
//             </thead>

//             <tbody>
//               {alerts.length === 0 && (
//                 <tr>
//                   <td colSpan="7" style={{ textAlign: "center" }}>
//                     No Fall Alerts Found
//                   </td>
//                 </tr>
//               )}

//               {alerts.map((alert) => (
//                 <tr key={alert.alert_id}>
//                   <td>
//                     {new Date(alert.occurred_at).toLocaleString()}
//                   </td>

//                   <td>{alert.patient_id}</td>

//                   <td>
//                     <Badge bg="secondary">
//                       {alert.event_type}
//                     </Badge>
//                   </td>

//                   <td>{alert.reason || "—"}</td>

//                   {/* STATUS */}
//                   <td>
//                     {alert.alert_acknowledged ? (
//                       <span style={{ color: "green", fontWeight: "bold" }}>
//                         Acknowledged
//                       </span>
//                     ) : (
//                       <span style={{ color: "red", fontWeight: "bold" }}>
//                         New
//                       </span>
//                     )}
//                   </td>

//                   {/* NOTE */}
//                   <td>{alert.note || "—"}</td>

//                   {/* OPERATIONS */}
//                   <td>
//                     {!alert.alert_acknowledged && (
//                       <Button
//                         size="sm"
//                         variant="success"
//                         style={{ marginRight: "8px" }}
//                         onClick={() => openAcknowledgeModal(alert)}
//                       >
//                         Acknowledge
//                       </Button>
//                     )}

//                     {alert.alert_acknowledged && (
//                       <span
//                         style={{
//                           color: "green",
//                           fontWeight: "bold",
//                           marginRight: "8px",
//                         }}
//                       >
//                         ✓
//                       </span>
//                     )}

//                     {alert.evidence_path && (
//                       <Button
//                         size="sm"
//                         variant="primary"
//                         onClick={() => openVideoModal(alert)}
//                       >
//                         View Evidence
//                       </Button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* ================= ACKNOWLEDGE MODAL ================= */}
//       <Modal
//         show={showAckModal}
//         onHide={() => setShowAckModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Acknowledge Alert</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <p>Optionally add a note before confirming.</p>

//           <Form.Group>
//             <Form.Label>Note (optional)</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               placeholder="Enter a note..."
//               value={note}
//               onChange={(e) => setNote(e.target.value)}
//             />
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => setShowAckModal(false)}
//           >
//             Cancel
//           </Button>

//           <Button
//             variant="success"
//             onClick={confirmAcknowledge}
//           >
//             Confirm
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ================= VIDEO MODAL ================= */}
//       <Modal
//         show={showVideoModal}
//         onHide={() => setShowVideoModal(false)}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Evidence Video</Modal.Title>
//         </Modal.Header>

//         <Modal.Body style={{ textAlign: "center" }}>
//           {selectedAlert?.evidence_path ? (
//             <video
//               width="100%"
//               controls
//               autoPlay
//               src={buildEvidenceUrl(selectedAlert.evidence_path)}
//               style={{ borderRadius: "8px", background: "#000" }}
//             />
//           ) : (
//             <p>No evidence available.</p>
//           )}
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// };




// export default FallAlerts;
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllFallAlerts,
  acknowledgeFallAlertById,
} from "../../redux/slices/AlertTableSlice";

import { Modal, Button, Form, Badge, Spinner } from "react-bootstrap";
import "./AdminCSS/Details.css";

const FallAlerts = () => {
  const dispatch = useDispatch();
  const { alerts = [], loading, error } = useSelector(
    (state) => state.fallAlerts
  );

  const [showAckModal, setShowAckModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [note, setNote] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [currentVideoAlertId, setCurrentVideoAlertId] = useState(null); // FIX: Per-button loading
  const [videoLoading, setVideoLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchAllFallAlerts());
  }, [dispatch]);

  const fetchVideoUrl = async (alertId) => {
    setCurrentVideoAlertId(alertId); // Track which button clicked
    setVideoLoading(true);
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/alerts_table/evidence-url/${alertId}`;
      console.log("🔍 Fetching SAS from:", apiUrl);
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error("❌ API Error:", errorText);
        throw new Error(`HTTP ${response.status}`);
      }
      
      const data = await response.json();
      console.log("✅ SAS URL ready");
      setVideoUrl(data.sas_url);
    } catch (err) {
      console.error("💥 Fetch failed:", err);
      setVideoUrl("");
    } finally {
      setVideoLoading(false);
    }
  };

  const openAcknowledgeModal = (alert) => {
    setSelectedAlert(alert);
    setNote(alert.note || "");
    setShowAckModal(true);
  };

  const confirmAcknowledge = () => {
    if (!selectedAlert) return;
    dispatch(acknowledgeFallAlertById({
      alertId: selectedAlert.alert_id,
      alert_acknowledged: true,
      note: note,
      user_id: selectedAlert.user_id,
    }));
    setShowAckModal(false);
  };

  const openVideoModal = async (alert) => {
    setSelectedAlert(alert);
    await fetchVideoUrl(alert.alert_id);
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setVideoUrl("");
    setCurrentVideoAlertId(null);
  };

  // Check if THIS specific button should show loading
  const isButtonLoading = (alertId) => currentVideoAlertId === alertId && videoLoading;

  return (
    <div className="Devices-page">
      <h2 style={{ marginBottom: "20px" }}>Fall Alerts</h2>

      {loading && <p>Loading fall alerts...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && (
        <div className="table-scroll-container">
          <table className="device-table">
            <thead>
              <tr>
                <th>Time</th>
                <th>Patient ID</th>
                <th>Event</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Note</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {alerts.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No Fall Alerts Found
                  </td>
                </tr>
              )}
              {alerts.map((alert) => (
                <tr key={alert.alert_id}>
                  <td>{new Date(alert.occurred_at).toLocaleString()}</td>
                  <td>{alert.patient_id}</td>
                  <td><Badge bg="secondary">{alert.event_type}</Badge></td>
                  <td>{alert.reason || "—"}</td>
                  <td>
                    {alert.alert_acknowledged ? (
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        Acknowledged
                      </span>
                    ) : (
                      <span style={{ color: "red", fontWeight: "bold" }}>New</span>
                    )}
                  </td>
                  <td>{alert.note || "—"}</td>
                  <td>
                    {!alert.alert_acknowledged && (
                      <Button
                        size="sm"
                        variant="success"
                        style={{ marginRight: "8px" }}
                        onClick={() => openAcknowledgeModal(alert)}
                      >
                        Acknowledge
                      </Button>
                    )}
                    {alert.alert_acknowledged && (
                      <span style={{ color: "green", fontWeight: "bold", marginRight: "8px" }}>
                        ✓
                      </span>
                    )}
                    {alert.evidence_path && (
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() => openVideoModal(alert)}
                        disabled={isButtonLoading(alert.alert_id)} // FIX: Only this button
                      >
                        {isButtonLoading(alert.alert_id) ? (  // FIX: Only this button shows loading
                          <>
                            <Spinner as="span" animation="border" size="sm" />
                            <span style={{ marginLeft: "5px" }}>Loading...</span>
                          </>
                        ) : "View Evidence"}
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ACKNOWLEDGE MODAL */}
      <Modal show={showAckModal} onHide={() => setShowAckModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Acknowledge Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Optionally add a note before confirming.</p>
          <Form.Group>
            <Form.Label>Note (optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter a note..."
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAckModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={confirmAcknowledge}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* CLEAN VIDEO MODAL - NO URL DISPLAY */}
      <Modal show={showVideoModal} onHide={closeVideoModal} centered className="video-modal-xl">
        <Modal.Header closeButton>
          <Modal.Title>Fall Evidence Video</Modal.Title>
        </Modal.Header>
        <Modal.Body className="video-modal-body">
          {videoLoading ? (
            <div className="video-loading">
              <Spinner animation="border" size="lg" />
              <p>Loading video...</p>
            </div>
          ) : !videoUrl ? (
            <div className="no-video">
              <p>No video available</p>
            </div>
          ) : (
            <div className="video-container">
              <video
                className="evidence-video"
                controls
                preload="metadata"
                src={videoUrl}
                playsInline
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default FallAlerts;